import { render, staticRenderFns } from "./IconPriceChange.vue?vue&type=template&id=7c7d3e3d"
import script from "./IconPriceChange.vue?vue&type=script&lang=js"
export * from "./IconPriceChange.vue?vue&type=script&lang=js"
import style0 from "./IconPriceChange.vue?vue&type=style&index=0&id=7c7d3e3d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports